<template>
  <div class="question-type-panel">
    <layout-panel hide-collapse>
      <template slot="header">
        题型列表
      </template>
      <ul class="question-type-list">
        <draggable
          v-model="typeList"
          :options="{sort: false, group: {name:'questions', pull:'clone', put:false}, disabled: disabled}"
          :clone="clone">
          <transition-group>
            <li v-for="type in typeList"
                :key="type">
              <el-button v-if="disabled"
                         :disabled="disabled"
                         plain
                         size="mini">
                {{types[type]}}
              </el-button>
              <sj-question-button
                v-else
                v-model="questions"
                action="add"
                :options="{type}">
                <el-button plain
                           size="mini">
                  {{types[type]}}
                </el-button>
              </sj-question-button>
            </li>
          </transition-group>
        </draggable>
      </ul>
    </layout-panel>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import SjQuestionButton from '@/views/question-editor/packages/sj-question/src/SjQuestionButton'
import questions from '@views/question-editor/utils/questions'
import options from '@views/question-editor/utils/options'

export default {
  components: {
    SjQuestionButton,
    draggable,
  },
  inject: ['page'],
  props: {
    value: Array,
    disabled: Boolean,
  },
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      types: state => state.types,
    }),
    typeList () {
      return Object.keys(this.types)
    },
    questions: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    clone (type) {
      let question = questions.make(type)
      if (question.options) {
        question.options.push(options.make(type))
        question.options.push(options.make(type))
      }
      return question
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.question-type-list {
  margin: 0;
  padding: 0;
  list-style-type: none;

  li {
    margin-bottom: 10px;
  }
}

button {
  white-space: normal;
  line-height: 18px;
}

</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateQuestionType.vue